var _desc, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplebarcodenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0.0000mm",
    y: "0.0000mm",
    width: "96.0440mm",
    height: "96.0440mm",
    viewBox: "0.0000 0.0000 96.0440 96.0440",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TBarCode - 11.17.1.16949") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "BarCode licensed to MEM:TEC-IT Datenverarbeitung GmbH Internal License")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(100%,100%,100%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 96.044,
    height: 96.044
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 0,
    width: 3.3119,
    height: 3.3119
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 3.3119,
    width: 3.3119,
    height: 3.3119
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 6.6237,
    width: 3.3119,
    height: 3.3119
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 9.9356,
    width: 3.3119,
    height: 3.3119
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 13.2474,
    width: 3.3119,
    height: 3.3119
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 16.5593,
    width: 3.3119,
    height: 3.3119
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 19.8712,
    width: 3.3119,
    height: 3.3119
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 23.183,
    width: 3.3119,
    height: 3.3119
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.183,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 26.4949,
    width: 3.3119,
    height: 3.3119
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.183,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 29.8068,
    width: 3.3119,
    height: 3.3119
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 33.1186,
    width: 3.3119,
    height: 3.3119
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 36.4305,
    width: 3.3119,
    height: 3.3119
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.183,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 39.7423,
    width: 3.3119,
    height: 3.3119
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 43.0542,
    width: 3.3119,
    height: 3.3119
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.183,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 46.3661,
    width: 3.3119,
    height: 3.3119
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 49.6779,
    width: 3.3119,
    height: 3.3119
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.183,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 52.9898,
    width: 3.3119,
    height: 3.3119
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 56.3017,
    width: 3.3119,
    height: 3.3119
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 59.6135,
    width: 3.3119,
    height: 3.3119
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 62.9254,
    width: 3.3119,
    height: 3.3119
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.183,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 66.2372,
    width: 3.3119,
    height: 3.3119
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 69.5491,
    width: 3.3119,
    height: 3.3119
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 72.861,
    width: 3.3119,
    height: 3.3119
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 76.1728,
    width: 3.3119,
    height: 3.3119
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 79.4847,
    width: 3.3119,
    height: 3.3119
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1084,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 82.7966,
    width: 3.3119,
    height: 3.3119
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1186,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1728,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7966,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 86.1084,
    width: 3.3119,
    height: 3.3119
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8068,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4305,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3661,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5491,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 89.4203,
    width: 3.3119,
    height: 3.3119
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3119,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6237,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9356,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2474,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5593,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8712,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4949,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7423,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0542,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6779,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9898,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3017,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6135,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9254,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2372,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4847,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4203,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7321,
    y: 92.7321,
    width: 3.3119,
    height: 3.3119
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplebarcodenew);
export default __webpack_public_path__ + "static/media/applebarcodenew.ceaedfca5cc06b328b49d3706c33f915.svg";
export { ForwardRef as ReactComponent };